import { z } from '@/utils/zod'

export const OrganizationClassificationTypeSchema = z.enum([
    'club',
    'association',
    'foundation',
    'charity',
    'church',
    'political',
    'cooperative',
    'gGmbH',
    'other',
])

export type OrganizationClassificationType = z.infer<typeof OrganizationClassificationTypeSchema>

export const OrganizationClassificationAreaSchema = z.enum([
    'culture',
    'political',
    'business',
    'environment',
    'human',
    'relax',
    'sports',
    'other',
])

export type OrganizationClassificationArea = z.infer<typeof OrganizationClassificationAreaSchema>

export const OrganizationClassificationSportSchema = z.enum([
    'airSports',
    'rockClimbing',
    'americanFootball',
    'cheerleading',
    'badminton',
    'baseball',
    'softball',
    'basketball',
    'disabilitySports',
    'billiards',
    'bobsleigh',
    'tobogganing',
    'skeleton',
    'boccia',
    'boule',
    'petanque',
    'boxing',
    'cricket',
    'curling',
    'darts',
    'iceHockey',
    'figureSkating',
    'iceDancing',
    'speedSkating',
    'shortTrack',
    'stickShooting',
    'fencing',
    'floorball',
    'football',
    'deafSports',
    'weightLifting',
    'golf',
    'handball',
    'hockey',
    'judo',
    'jujutsu',
    'canoeing',
    'karate',
    'bowling',
    'kickboxing',
    'powerLifting',
    'rescueSports',
    'athletics',
    'miniGolf',
    'motorsport',
    'motorboating',
    'cycling',
    'lawnPowerSports',
    'tugOfWar',
    'equestrianSports',
    'wrestling',
    'roller',
    'inlineSkating',
    'rowing',
    'rugby',
    'chess',
    'shooting',
    'swimming',
    'sailing',
    'skibob',
    'ski',
    'acrobatics',
    'scuba',
    'squash',
    'taekwondo',
    'dancing',
    'tennis',
    'tableTennis',
    'triathlon',
    'gymnastics',
    'snowboard',
    'pentathlon',
    'volleyball',
    'waterSki',
    'wakeboard',
    'surfing',
    'martialArts',
    'kungFu',
    'fistball',
    'eSports',
    'aikido',
    'multispeciality',
    'archery',
    'standUpPaddle',
    'taiChi',
    'qiGong',
    'sanda',
    'selfDefense',
    'fitness',
    'childrenSport',
    'running',
    'ropeSkipping',
    'shuttlecock',
    'fingerBoarding',
    'flagFootball',
    'flightModel',
    'frisbee',
    'climbing',
    'walking',
    'geocaching',
    'paragliding',
    'jiuJutsu',
    'kendo',
    'kravMaga',
    'lacrosse',
    'mountainBiking',
    'muayThai',
    'nordicWalking',
    'orienteeringRace',
    'paintBall',
    'parkour',
    'poker',
    'polo',
    'poleDance',
    'prellball',
    'racketlon',
    'waterSport',
    'skateboarding',
    'stockschiessen',
    'wingTsun',
    'wushu',
    'circus',
    'popularSport',
    'other',
    'skiing',
    'snowboarding',
    'crossCountrySkiing',
])

export type OrganizationClassificationSport = z.infer<typeof OrganizationClassificationSportSchema>

export const OrganizationClassificationSchema = z
    .object({
        type: OrganizationClassificationTypeSchema,
        area: OrganizationClassificationAreaSchema,
        sports: z.uniqueArray(OrganizationClassificationSportSchema),
    })
    .check(({ value, ...ctx }) => {
        if (value.area === 'sports' && value.sports.length === 0) {
            ctx.issues.push({
                code: 'custom',
                input: value,
                params: {
                    i18n: { key: 'custom.required' },
                },
                path: ['sports'],
            })
        }
    })

export type OrganizationClassification = z.infer<typeof OrganizationClassificationSchema>
